export default "__VITE_ASSET__DSWDsEjm__"